<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">志愿者</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <div style="padding-left: 10px;">
          <el-button type="primary" size="mini" plain @click.native="showElderly">添加</el-button>
          <div style="clear:both;"></div>
        </div>

        <el-row style="margin-top:10px">
          <el-col :span="24">
            <el-table :data="tableData" size="mini" ref="tableElderlyRel" style="width: 100%" border :height="300">

              <el-table-column label="志愿队伍" prop="volunteerTeamName" width="100"></el-table-column>
              <el-table-column label="姓名" prop="elderlyName" width="100"></el-table-column>
              <el-table-column label="手机号" prop="phone"></el-table-column>

              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click.native.prevent="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-col>
        </el-row>

        <div class="page">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="pageSize"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>

    <Elderly ref="myElderly" v-show="showModalSelectAdd"
                   v-on:setElderly="setElderly" v-on:closeElderly="closeElderly" v-on:getList="getList"></Elderly>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Elderly from "@/views/Elderly/Comm/ElderlyGov";

export default {
  name: 'ElderlyRel',
  props:[],
  data() {
    return {
      showModalSelectAdd:false,

      loading: false,

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      volunteerTeamCode:'',

    }
  },
  components:{Elderly},
  methods: {
    init(row){
      this.volunteerTeamCode = row.volunteerTeamCode;
      this.getList()
    },
    closeSelf() {
      this.$emit("closeElderlyRel");
    },

    showElderly(){
      this.showModalSelectAdd = !this.showModalSelectAdd;
      this.$refs.myElderly.init();
    },
    closeElderly:function(){
      this.showModalSelectAdd = !this.showModalSelectAdd;
    },

    setElderly(row){
      let elderlyCode = row.elderlyCode;
      this.addRel(elderlyCode);
    },




    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"VolunteerTeamElderlyRel/PageByVolunteerTeamCode",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          volunteerTeamCode:this.volunteerTeamCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.tableData=response.data.data.pageInfo.list;
              this.totalItems = response.data.data.pageInfo.total;
              this.$nextTick(()=>{
                this.$refs.tableElderlyRel.doLayout();
              });

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          })
    },


    handleDelete(index,row){

      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl+"VolunteerTeamElderlyRel/DeleteElderlyRel",
          data: {
            timeStr:timeStr,
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            staffCode: getStaffCode(),
            volunteerTeamElderlyRelCode:row.volunteerTeamElderlyRelCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.$message.info("删除成功");

            this.getList();

          }else if(response.data.error == 1){
            this.$message({type: 'info', message: response.data.message});
          }
        })

      }).catch(e=>e)



    },

    addRel(elderlyCode){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"VolunteerTeamElderlyRel/AddElderlyRel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          volunteerTeamCode:this.volunteerTeamCode,
          elderlyCode:elderlyCode,
        }
      }).then((response) => {
        if (response.data.error == 0) {

          this.getList();

        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      })

    }


  }
}


</script>


